import {StakingData} from '@/providers/overview/useStakingData';
import {useMemo} from 'react';
import {ChartData} from '@/providers/overview/OverviewProvider';
import {useStakingPositions} from '@/providers/overview/useStakingPositions';
import {useTokenPositions} from '@/providers/overview/useTokenPositions';
import {AssetManagerData} from '@/api-requests/asset-managers';
import {useAssetManagerPositions} from './useAssetManagerPositions';
import {AccountAssetManagerData} from './useAssetManagerData';

export function usePositions(
  chartData: ChartData,
  stakingData?: StakingData,
  stakingDataOLD?: StakingData | null,
  assetManagers?: AssetManagerData[],
  assetManagerData?: AccountAssetManagerData
) {
  const stakingPositions = useStakingPositions(chartData, stakingData);
  const stakingPositionsOLD = useStakingPositions(
    chartData,
    stakingDataOLD || undefined
  );
  const tokenPositions = useTokenPositions(chartData);
  const assetManagerPositions = useAssetManagerPositions(
    chartData,
    assetManagers,
    assetManagerData
  );

  return useMemo(() => {
    return [
      ...tokenPositions,
      ...stakingPositions,
      ...stakingPositionsOLD.map(position => ({
        ...position,
        old: true,
      })),
      ...assetManagerPositions,
    ];
  }, [
    stakingPositions,
    stakingPositionsOLD,
    tokenPositions,
    assetManagerPositions,
  ]);
}
